import './App.css';

import { Route, Routes } from "react-router-dom";

//layoud 
import MainContainer from './layouts/MainContainer';

//Pages
import HomePage from './pages/HomePage';
import AmbientalPage from './pages/AmbientalPage';
import ZonasVerdesPage from './pages/ZonasVerdesPage';
import PuntosInteresPage from './pages/PuntosInteresPage';
import ViviendasExistentesPage from './pages/ViviendasExistentesPage';
import ViviendasConstruccionPage from './pages/ViviendasConstruccionPage';
import ViviendasFuturasPage from './pages/ViviendasFuturasPage';

function App() {
  document.title = "Maipore";

  return (
    <MainContainer>      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/*" element={<HomePage />} />
        <Route path="home" element={<HomePage/>} />
        <Route path="ambiental" element={<AmbientalPage/>} />
        <Route path="zonas_verdes" element={<ZonasVerdesPage/>} />
        <Route path="puntos_interes" element={<PuntosInteresPage/>} />
        <Route path="viviendas_existentes" element={<ViviendasExistentesPage/>} />
        <Route path="viviendas_construccion" element={<ViviendasConstruccionPage/>} />
        <Route path="viviendas_futuras" element={<ViviendasFuturasPage/>} />
      </Routes>
    </MainContainer>
  );
}

export default App;
